import { ArbeitsbereichOption } from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitsbereichOption';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { useTranslation } from 'react-i18next';
import z from 'zod';

export function useCreateAndUpdateSchema() {
  const { t } = useTranslation();

  const schema = z.object({
    standort: z.instanceof(Standort, {
      message: t('generalValidationError.required'),
    }),
    arbeitsbereich: z.instanceof(ArbeitsbereichOption, {
      message: t('generalValidationError.required'),
    }),
    von: z.date({
      message: t('generalValidationError.required'),
    }),
    bis: z.date({
      message: t('generalValidationError.required'),
    }),
    lernziele: z
      .string()
      .max(400, {
        message: t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.lernziele.tooLong',
        ),
      })
      .optional(),
  });

  return schema;
}
